import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

export default function AiAgents(props) {
    const data = {
        url: '/admin/ai/agents',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/ai/agents/{id}',
        userfilter:[
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Client',
                source: 'client_id',
                type: 'select',
                editable: false,
                default: '',
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Voice',
                source: 'voice_id',
                type: 'select',
                editable: false,
                default: '',
            },
            {
                label: 'Language',
                source: 'language',
                type: 'text',
                editable: false,
                default: '',
            },
            {
                label: 'Speech Style',
                source: 'speech_style_id',
                type: 'select',
                editable: false,
                default: '',
            },
            {
                label: 'Model',
                source: 'model',
                type: 'text',
                editable: false,
                default: '',
            },
            {
                label: 'Enabled',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    true: 'YES',
                    false: 'NO'
                },
                classnames: {
                    1: 'label label-info',
                    0: 'label label-danger'
                }
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="AI Agents">
            <>            
                <Tabs tabs={aiTabs} />
                <DataResource
                    addButtonText="Create New AI Agent"
                    addButtonType="link"
                    addButtonLink="/ai/agents/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}